import { render, staticRenderFns } from "./BillSet.vue?vue&type=template&id=2bcb24a7&"
import script from "./BillSet.vue?vue&type=script&lang=js&"
export * from "./BillSet.vue?vue&type=script&lang=js&"
import style0 from "./BillSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports